class EventEmitter {
    constructor() {
      this.events = {};
    }
    // 订阅事件
    on(event, listener) {
      if (!this.events[event]) {
        this.events[event] = [];
      }
      this.events[event].push(listener);
    }
  
    // 取消订阅事件
    off(event, listener) {
      if (!this.events[event]) return;
  
      this.events[event] = this.events[event].filter(l => l !== listener);
    }
  
    // 触发事件
    emit(event, ...args) {
      if (!this.events[event]) return;
  
      this.events[event].forEach(listener => {
        listener(...args);
      });
    }
  }
  
  // 创建一个全局事件管理器实例
  const eventEmitter = new EventEmitter();
  Object.freeze(eventEmitter);
  export default eventEmitter;